import { BaseColumnFormatter, TableColumnInfo, TableRowInfo } from "namirasoft-site-react";

export class HiddenWhenZeroFormatter extends BaseColumnFormatter
{
    private formatter: BaseColumnFormatter;
    private field: string;

    constructor(formatter: BaseColumnFormatter, field: string)
    {
        super();
        this.formatter = formatter;
        this.field = field;
        this.width = formatter.width;
        this.onclick_overrided = formatter.onclick_overrided;
    }

    override format(value: any, column: TableColumnInfo, row: TableRowInfo<any>, printable: boolean): any
    {
        let gate = row?.value?.[this.field];
        if (gate == null || Number(gate) === 0)
            return "";
        return this.formatter.format(value, column, row, printable);
    }

    override compare(a: any, b: any): number
    {
        return this.formatter.compare(a, b);
    }
}